"use client";

import Clarity from "@microsoft/clarity";

const isDev = process.env.NODE_ENV === "development";

let isInitialized = false;

type T_ClarityConsentStorage = "granted" | "denied";

type T_ClarityConsentOptions = {
  ad_Storage: T_ClarityConsentStorage;
  analytics_Storage: T_ClarityConsentStorage;
};

export function initClarity(projectId?: string): boolean {
  if (typeof window === "undefined") return false;
  if (isInitialized) return true;
  const trimmedProjectId = projectId?.trim();
  if (!trimmedProjectId) return false;

  Clarity.init(trimmedProjectId);
  isInitialized = true;

  if (isDev) {
    console.log("[Clarity] Initialized");
  }

  return true;
}

export function setClarityConsent(options: T_ClarityConsentOptions): void {
  if (!isInitialized) return;

  Clarity.consentV2(options);

  if (isDev) {
    console.log("[Clarity] Consent updated", options);
  }
}

export function identifyClarityUser(
  customId: string,
  customSessionId?: string,
  customPageId?: string,
  friendlyName?: string,
): void {
  if (!isInitialized || !customId) return;

  Clarity.identify(customId, customSessionId, customPageId, friendlyName);

  if (isDev) {
    console.log("[Clarity] Identified user", customId);
  }
}

export function setClarityTag(key: string, value: string | string[]): void {
  if (!isInitialized) return;

  Clarity.setTag(key, value);

  if (isDev) {
    console.log("[Clarity] Tag set", key, value);
  }
}

export function trackClarityEvent(eventName: string): void {
  if (!isInitialized || !eventName) return;

  Clarity.event(eventName);

  if (isDev) {
    console.log("[Clarity] Event", eventName);
  }
}
